/* Format the existing English shipping policy; never replace its business terms. */
(() => {
  const body = document.querySelector('.shopify-policy__body .rte');
  // A policy already formatted in Shopify's editor needs no conversion.
  if (!body || body.querySelector('h2, h3, table, ul, ol')) return;
  const headings = new Set([
    'Shipping Origin & Destinations', 'Order Processing', 'Shipping Rates',
    'Estimated Delivery Time', 'Order Tracking',
    'Customs Duties, Import Taxes & Clearance Fees',
    'Shipping Address & Order Changes', 'Order Cancellations Before Shipment',
    'Final Sale After Shipment', 'Delayed or Lost Packages',
    'Damaged, Defective, or Incorrect Items', 'Refund Processing',
    'Your Consumer Rights', 'Contact Us'
  ]);
  const text = node => node.textContent.trim();
  const plainParagraph = node => node?.tagName === 'P' && !node.querySelector('*');
  const paragraphs = [...body.children].filter(node => node.tagName === 'P');
  if (!paragraphs.some(node => headings.has(text(node)))) return;

  paragraphs.forEach(paragraph => {
    if (!plainParagraph(paragraph) || !headings.has(text(paragraph))) return;
    const heading = document.createElement('h2');
    heading.append(...paragraph.childNodes);
    paragraph.replaceWith(heading);
  });

  // Only convert the two known, plain-text tables; leave unknown text untouched.
  const tableHeaders = new Set([
    'Order subtotal | Standard shipping', 'Destination | Estimated shipping time'
  ]);
  [...body.children].forEach(paragraph => {
    if (!plainParagraph(paragraph) || !tableHeaders.has(text(paragraph))) return;
    const rows = [];
    let current = paragraph;
    while (plainParagraph(current) && text(current).split('|').length === 2) {
      rows.push(current);
      current = current.nextElementSibling;
    }
    if (rows.length < 2) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'ntod-policy-table';
    const table = document.createElement('table');
    const caption = document.createElement('caption');
    caption.className = 'visually-hidden';
    caption.textContent = paragraph.previousElementSibling?.previousElementSibling?.textContent || text(paragraph);
    const thead = document.createElement('thead');
    const tbody = document.createElement('tbody');
    rows.forEach((row, index) => {
      const tr = document.createElement('tr');
      text(row).split('|').forEach((value, column) => {
        const cell = document.createElement(index === 0 || column === 0 ? 'th' : 'td');
        if (cell.tagName === 'TH') cell.scope = index === 0 ? 'col' : 'row';
        cell.textContent = value.trim();
        tr.append(cell);
      });
      (index === 0 ? thead : tbody).append(tr);
    });
    table.append(caption, thead, tbody);
    wrapper.append(table);
    paragraph.before(wrapper);
    rows.forEach(row => row.remove());
  });

  [...body.children].forEach(paragraph => {
    if (!paragraph.isConnected || !plainParagraph(paragraph) || !text(paragraph).startsWith('• ')) return;
    const list = document.createElement('ul');
    paragraph.before(list);
    let current = paragraph;
    while (plainParagraph(current) && text(current).startsWith('• ')) {
      const next = current.nextElementSibling;
      const item = document.createElement('li');
      item.textContent = text(current).replace(/^•\s*/, '');
      list.append(item);
      current.remove();
      current = next;
    }
  });
  body.classList.add('ntod-shipping-policy');
})();
